import { FC } from "react";
import Image from "next/image";
import { useRouter } from "next/router";
import { BlogCardType } from "@/components/page-modules/blog/data/blog.types";
import { useHomePageTypesButton } from "@/states/ui.state";
import { useSolutionsSelect } from "@/states/solution.state";
import { useFrom } from "@/states/common.state";
import style from "../Blog.module.scss";
const BlogCard: FC<BlogCardType> = ({
  blogData
}) => {
  const {
    author,
    image,
    createdAt,
    title,
    slug,
    imageAltAttribute,
    qrType
  } = blogData;
  const router = useRouter();
  const {
    homePageTypesButton,
    setFilterHomePageTypesButton
  } = useHomePageTypesButton();
  const {
    setSolutionsType
  } = useSolutionsSelect();
  const {
    setFrom
  } = useFrom();
  const handleClick = () => {
    const selectedType = homePageTypesButton.filter(e => e.type === qrType);
    if (selectedType && selectedType?.length > 0) {
      setSolutionsType({
        solutionSelectedType: selectedType[0].type
      });
      setFilterHomePageTypesButton(selectedType[0].type);
      setFrom("solutions");
    }
    router.push(`/${slug}`);
  };
  return <div className={style.card} onClick={handleClick} data-sentry-component="BlogCard" data-sentry-source-file="Card.tsx">
      <div className={style.card__image}>
        <Image src={image} fill alt={imageAltAttribute} sizes={"100%"} data-sentry-element="Image" data-sentry-source-file="Card.tsx" />
      </div>
      <div className={style.card__body}>
        <div className={style.card__title}>{title}</div>
        <div className={style.card__info}>
          <p>{author?.name}</p>
          <p>{createdAt}</p>
        </div>
      </div>
    </div>;
};
export default BlogCard;